var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngineering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.49 105.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .eng-cls-1 {\n        fill: #39fdc1;\n      }\n\n      .eng-cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Engineering_Button_Slider",
    "data-name": "Engineering Button Slider"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "eng-cls-1",
    cx: 52.74,
    cy: 52.74,
    r: 52.74
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "eng-cls-2",
    d: "M445.14,212.3a29.49,29.49,0,1,0,29.48,29.49A29.48,29.48,0,0,0,445.14,212.3Zm0,38.61a9.12,9.12,0,1,1,9.12-9.12A9.13,9.13,0,0,1,445.14,250.91Z",
    transform: "translate(-392.4 -189.04)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "eng-cls-2",
    x: 46.89,
    y: 12.78,
    width: 11.71,
    height: 22.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eng-cls-2",
    x: 46.89,
    y: 69.9,
    width: 11.71,
    height: 22.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "eng-cls-2",
    x: 467.85,
    y: 230.38,
    width: 11.71,
    height: 22.81,
    transform: "translate(323.09 -420.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eng-cls-2",
    x: 410.73,
    y: 230.38,
    width: 11.71,
    height: 22.81,
    transform: "translate(265.97 -363.84) rotate(90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "eng-cls-2",
    x: 459.48,
    y: 250.58,
    width: 11.71,
    height: 22.81,
    transform: "translate(587.23 -70.86) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eng-cls-2",
    x: 419.1,
    y: 210.19,
    width: 11.71,
    height: 22.81,
    transform: "translate(489.73 -111.24) rotate(135)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "eng-cls-2",
    x: 419.1,
    y: 250.58,
    width: 11.71,
    height: 22.81,
    transform: "translate(147.79 558.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "eng-cls-2",
    x: 459.48,
    y: 210.19,
    width: 11.71,
    height: 22.81,
    transform: "translate(245.29 518.28) rotate(-135)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngineering);
export default __webpack_public_path__ + "static/media/Engineering.33b0c57101648b97d92a6cb3ee0dfa3b.svg";
export { ForwardRef as ReactComponent };